var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAbout = function SvgAbout(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    xmlSpace: "preserve"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 7.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 7v4M8 5h0"
  }))));
};
export { SvgAbout as ReactComponent };
export default "data:image/svg+xml,%3c!-- 16x16 outlined info/about icon --%3e %3csvg version='1.1' id='Lager_1' xmlns='http://www.w3.org/2000/svg' x='0' y='0' viewBox='0 0 16 16' xml:space='preserve'%3e %3cg fill='none' stroke='currentColor' stroke-width='1' stroke-linecap='round' stroke-linejoin='round'%3e %3c!-- outer circle --%3e %3ccircle cx='8' cy='8' r='7.5'/%3e %3c!-- info stem --%3e %3cline x1='8' y1='7' x2='8' y2='11'/%3e %3c!-- info dot --%3e %3cline x1='8' y1='5' x2='8' y2='5'/%3e %3c/g%3e %3c/svg%3e";